import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Button, Stack, Paper, Typography, IconButton,
         useMediaQuery } from '@mui/material';
import { Close, Delete, OpenInNew } from '@mui/icons-material';
import { auth, wsurl } from '../Common';

/**
 * Richieste di eliminazione in attesa, per gli amministratori (decisione di Gabriele,
 * 28/09/2026: chi non è amministratore chiede, l'amministratore approva). Per ognuna: foto,
 * titolo, concessionaria, chi l'ha chiesta e perché. Si apre la scheda per guardarla meglio,
 * si approva (l'impianto viene eliminato, dopo una conferma) o si rifiuta (resta com'è).
 */
export default function RichiesteEliminazione({ open, onClose, richieste, onApri, onCambiate, notify }) {
  const telefono = useMediaQuery('(max-width:700px)');
  const [conferma, setConferma] = useState(null);   // impianto in attesa di conferma dell'eliminazione
  const [busy, setBusy] = useState(false);

  const decidi = async (r, approva) => {
    setBusy(true);
    try {
      await auth.decidiEliminazione(r.eliminazione.richiesta, approva);
      notify(approva ? `Cartellone ${r.id} eliminato` : `Richiesta rifiutata: il cartellone ${r.id} resta`, approva ? 'info' : 'success');
      setConferma(null);
      onCambiate();
    } catch (e) {
      notify(e.message || 'Operazione non riuscita, riprova', 'error');
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" fullScreen={telefono}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', fontWeight: 800 }}>
        Richieste di eliminazione
        <Box flex={1} />
        <IconButton onClick={onClose} aria-label="Chiudi"><Close /></IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {!richieste.length && <Typography color="text.secondary">Nessuna richiesta in attesa.</Typography>}
        <Stack spacing={1.5}>
          {richieste.map(({ raw: r }) => (
            <Paper key={r.id} variant="outlined" sx={{ p: 1.5, display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
              <img src={`${wsurl}/image/${r.id}`} alt="" width={96} height={72} loading="lazy"
                   style={{ objectFit: 'cover', borderRadius: 8, flexShrink: 0, background: '#e2e8f0' }} />
              <Stack spacing={0.4} sx={{ minWidth: 0, flex: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, overflowWrap: 'anywhere' }}>
                  #{r.id} {r.title || 'senza titolo'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {/* l'account di una concessionaria ha il suo nome: "chiesta da" lo ripeterebbe */}
                  {r.azienda || 'nessuna concessionaria'} · chiesta
                  {r.eliminazione.da && r.eliminazione.da !== r.azienda ? ` da ${r.eliminazione.da}` : ''} il {r.eliminazione.il}
                </Typography>
                {r.eliminazione.motivo && (
                  <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>Motivo: «{r.eliminazione.motivo}»</Typography>
                )}
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ pt: 0.5 }}>
                  {conferma === r.id ? (<>
                    <Button size="small" color="error" variant="contained" disabled={busy}
                            onClick={() => decidi(r, true)}>Conferma: elimina</Button>
                    <Button size="small" disabled={busy} onClick={() => setConferma(null)}>Annulla</Button>
                  </>) : (<>
                    <Button size="small" color="error" variant="outlined" startIcon={<Delete />} disabled={busy}
                            onClick={() => setConferma(r.id)}>Approva ed elimina</Button>
                    <Button size="small" variant="outlined" disabled={busy} onClick={() => decidi(r, false)}>Rifiuta</Button>
                    <Button size="small" endIcon={<OpenInNew />} onClick={() => onApri(r.id)}>Apri la scheda</Button>
                  </>)}
                </Stack>
              </Stack>
            </Paper>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
